import React from 'react'


function Accomplishments() {
    return (
<div className="topacc">
    <div className="mainHeadingAbout">
            Honors and Awards
    </div>
   
   
   
    <div>
        <div className= "heading-topacc">
        Recognitions at Full-time Job at Nokia, Ottawa
        </div>
        <hr></hr>
        <div>
         <ol>
         <li><b>In top 5 of Nokia'a got talent around the Globe</b> </li>
             <li><b>Praise Excellence Award for early career empowered</b></li>
             <li><b>Delivered a talk to Nokia interns sharing my journey from intern to full-time employee</b></li>

             <li><b>Web Application Lead at Nokia's StrongHer Canada where I volunteered to handle technical things(June 2023 - present)</b></li>
            <li><b>Certifications on Kubernetes, Deep learning using Keras, Cloud from Nokia's internal learning portal</b></li>
        </ol>   
        </div>
    </div>
   
   
   
   
    <div>
        <div className= "heading-topacc">
        Leadership Recognitions
        </div>
        <hr></hr>
        <div>
         <ol>
         <li><b>ICPC Training Coach University of Windsor(Oct 2021 - Present)</b>: Conducting sessions for teaching data structures and algorithms <br></br>for ICPC contest preparation</li>
             <li><b>Vice-chairperson IEEE CS MSIT(2019-2020)</b>: Responsible for organizing Tech events, Coding contests,<br></br> and other technical sessions along with other core members.</li>
             <li><b>General Secretary IEEE CS MSIT(2018-2019)</b>: Responsible for documentation and organizing the Tech events with other core members.<br></br>
Was problem setter for three competitive coding contests organized by IEEE CS MSIT on HackerEarth and CodeChef.</li>
             <li><b>Massachusetts Institute of Technology(MIT) Innovation and Entrepreneurship Bootcamp 2018</b>:<br></br> Selected in MIT bootcamp in Brisbane, Australia</li>
             <li><b> Android SIG Head IEEE MSIT (Oct 2017 – Apr 2018)</b>: Conducted weekly sessions for android app development in java</li>
            
            
        </ol>   
        </div>
    </div>
    <div>
        <div className= "heading-topacc">
        Coding Recognitions
        </div>
        <hr></hr>
        <div>
         <ol>
             <li><b>Hackwithinfy 2020</b>: In the top 500 of Hackwithinfy coding challenge out of 1,18,000+ 
             participants from all over the country.<br></br> Got pre-placement interview opportunity and landed a job 
             offer at infosys.</li>
             <li><b>Codechef Snackdown 2019</b>: Codechef Snackdown 2019 qualified. Round-1 global
              rank-445(Qualified for pre-elimination)</li>
              <li><b>ACM-ICPC</b>: ACM-ICPC contest profile: <a href= 'https://icpc.baylor.edu/ICPCID/GY7H8XC80I53'>click here</a><br></br>Asia Kolkata-Kanpur Preliminary Online Contest
Team: redSword, rank: 93, Ninety-third Place. <br></br>Asia Amritapuri First Round Online Programming Contest
Team: redSword, rank: 348, Honorable Mention<br></br></li>
<li><b>Facebook hackercup 2018, 2019 and 2021</b>: Facebook hackercup 2018, 2019, 2021 qualified</li>


              
        </ol>   
        </div>
    </div>
    <div>
        <div className= "heading-topacc">
        Academic Recognitions
        </div>
        <hr></hr>
        <div>
         <ol>
             <li><b> B.Tech in computer science and engineering</b> Percentage: 87.6% (Top 10%)</li>
             <li><b>Class 12th(2016) (CBSE)</b>: Percentage: 94.2% [Non-Medical with computer science] awarded merit certificate and Trophy</li>

<li><b>National Interactive Math Olympiad 2015</b>: Got silver medal for National Interactive Math Olympiad in class 11th</li>
              <li><b>Class 10th(2014) (CBSE) </b>: CGPA- 9.8/10 awarded merit certificate and Scholar Blazer</li>    
              <li><b>Class 9th(2013) (CBSE) </b>: Awarded super scholar badge</li>  
              <li><b>Class 7th and 8th(2012, 2013) (CBSE) </b>: Awarded scholar badge-1 and scholar badge-2 respectively</li>         
        </ol>   
        </div>
    </div>
    <div>
        <div className= "heading-topacc">
            Research Recognitions
        </div>
        <hr></hr>
        <div>
         <ol>
             <li>Efficient Automated Disease Diagnosis Using Machine Learning Models</li><b>Published in Journal of Healthcare Engineering(Impact factor 2.68)</b>
             <li>Predicting optimal diabetes drug management using AI/ ML – Developing a prototype clinical decision support algorithm.</li><b>Published in European Congress of Endocrinology 2021</b><br></br> 
             <li>Modified COVID-19 Indian and International Dataset for Automatic Prediction of Risk in an Individual Using<br></br> Machine Learning Models using a Mobile APP<b> <br></br>Published in International Journal of Intelligent Engineering Informatics in 2021</b></li>
             <li>Air Pollution Prediction using RNN, LSTM and Hybrid of CNN and LSTM models<br></br><b>Published in Journal of
                  Computational and Theoretical Nanoscience (American Scientific Publishers) in 2020</b></li>
            <li>Deeper into Image Classification<br></br><b>Published in the Springer Singapore conference in 2020. 
                I presented the paper on February 21st, 2020.</b></li>

                <li>Drug prescription patterns and cost analysis of diabetes therapy in India: Audit of an endocrine practice<br></br><b>Published in the publication descriptionIndian Journal of Endocrinology and Metabolism in 2019.
                <br></br>I presented the paper in SPEEDCON conference.</b></li>


                <li>Automation of Insulin Bolus Dose Calculation in Type 1 Diabetes<br></br><b>Abstract published in the publication descriptionIndian Journal of Endocrinology and Metabolism in 2020. 
                </b></li>


                <li>A Comparative Study of Deep Learning Models on Air Pollution Forecasting<b><br></br>Published in the Scopus journal in 2020 
               </b></li>

              
        </ol>   
        </div>
    </div>
    
 
</div>

    
       
        
 
    )
}

export default Accomplishments;
